define([
    'system/domain/entity/record-shape-pattern',
    'underscore'
], function(
    Pattern
    )
{
    var rawTypes = {
        node: {
            name: 'Node',
            shape: Pattern.rect
        },
        requirement: {
            name: 'Requirement',
            shape: Pattern.rect
        },
        action: {
            name: 'Action',
            shape: Pattern.rectRound
        },
        object: {
            name: 'Object',
            shape: Pattern.rect
        },
        'fork-or-join': {
            name: 'Fork/Join',
            hideName: true,
            shape: Pattern.barV
        },
        'decision-or-merge': {
            name: 'Decision/Merge',
            shape: Pattern.diamond
        },
        element: {
            name: 'Element',
            shape: Pattern.circle
        },
        subject: {
            name: 'Subject',
            shape: Pattern.squareL
        },
        organization: {
            name: 'Organization',
            shape: Pattern.ellipse
        },
        person: {
            name: 'Person',
            shape: Pattern.circle
        },
        goal: {
            name: 'Goal',
            shape: Pattern.rect
        },
        evidence: {
            name: 'Evidence',
            shape: Pattern.ellipse
        },
        strategy: {
            name: 'Strategy',
            shape: Pattern.parallelogram
        },
        context: {
            name: 'Context',
            shape: Pattern.rectRound
        },
        undeveloped: {
            name: 'Undeveloped',
            shape: Pattern.diamond
        },
        screen: {
            name: 'Screen',
            shape: Pattern.squareL
        },
        event: {
            name: 'Event',
            shape: Pattern.square},
        task: {
            name: 'Task',
            shape: Pattern.square},
        sync: {
            name: 'Sync',
            shape: Pattern.circleS},
        usecase: {
            name: 'Use Case',
            shape: Pattern.ellipse},
        actor: {
            name: 'Actor',
            shape: Pattern.human},
        TestTree_TestCase: {
            name: 'Test Case',
            shape: Pattern.rect},
        Activity_Initial: {
            name: 'Initial',
            hideName: true,
            shape: Pattern.circleSFilled},
        Activity_ActivityFinal: {
            name: 'Final',
            hideName: true,
            shape: Pattern.circleO},
        Activity_FlowFinal: {
            name: 'Final',
            hideName: true,
            shape: Pattern.circleX},
        Activity_Parameter: {
            name: 'Parameter',
            shape: Pattern.rect},
        Block: {
            name: 'Block',
            shape: Pattern.rect},
        ValueType: {
            name: 'ValueType',
            shape: Pattern.rect},
        state: {
            name: 'State',
            shape: Pattern.rect},
        Class: {
            name: 'Class',
            shape: Pattern.rect},
        Interface: {
            name: 'Interface',
            shape: Pattern.rect},
        Package: {
            name: 'Package',
            shape: Pattern.package},
        CircuitElement: {
            name: 'Element',
            shape: Pattern.rect},
        CircuitSwitch: {
            name: 'Switch',
            shape: Pattern.squareM},
        CircuitGround: {
            name: 'Ground',
            shape: Pattern.triangleDown},
        CircuitTerminal: {
            name: 'Terminal',
            shape: Pattern.circleM},
    };

    var types = [];
    _.each(rawTypes, function(obj, type) {
        var d = _.extend({}, obj);
        d.id = type;
        d.type = type;
        types.push(d);
    });

    return types;
});



// WEBPACK FOOTER //
// ./system/domain/entity/default-record-types.js